import STYLES from './LocationPinMarker.module.scss';

type Props =
  | { variant: 'primary' | 'danger'; 'aria-label': string; 'aria-hidden'?: never }
  | { variant: 'primary' | 'danger'; 'aria-hidden': true; 'aria-label'?: never };

export const LocationPinMarker = ({
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
  variant,
}: Props) => (
  <div
    className={`${STYLES.pin} ${STYLES[variant]}`}
    role={ariaHidden ? undefined : 'img'}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden}
  />
);
